import { render } from "./ModalOrganizationCreate.vue?vue&type=template&id=321ccd11&scoped=true"
import script from "./ModalOrganizationCreate.vue?vue&type=script&lang=js"
export * from "./ModalOrganizationCreate.vue?vue&type=script&lang=js"

import "./ModalOrganizationCreate.vue?vue&type=style&index=0&id=321ccd11&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321ccd11"]])

export default __exports__